/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Original_Language_HelpInputs */



/**
* | output |
* | --- |
* | "Select the original language for this guide" |
*
* @param {Knp_Guide_Original_Language_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_original_language_help = /** @type {((inputs?: Knp_Guide_Original_Language_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Original_Language_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez la langue d’origine de ce guide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Originalsprache für diese Anleitung aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la lingua originale per questa guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите исходный язык для этого руководства.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el idioma original para esta guía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择本指南的原始语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このガイドの元の言語を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस मार्गदर्शिका के लिए मूल भाषा का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o idioma original deste guia.")
	return /** @type {LocalizedString} */ ("Select the original language for this guide")
});